export default {
  "header": {
    "connect_wallet": "连接钱包",
    "error_network": "错误网络"
  },
  "home": {
    "bind_address": "绑定邀请人地址",
    "start_training": "开始训练",
    "bind_now": "立即绑定"
  },
  "friend": {
    "level": "等级",
    "boost_score": "贡献值",
    "copy_link": "复制链接",
    "invite_friend": "邀请好友，赢得 AIP",
    "direct_invite": "直邀列表",
    "empty_invite_list": "暂无邀请好友",
    "team_size": "团队人数",
  },
  "data": {
    "withdraw_team_reward": "提取团队奖励",
    "withdraw_training_reward": "提取训练奖励",
    "training_data": "训练数据",
    "total_trainers": "总人数",
    "total_training_data": "总训练数",
    "training_rewards": "训练奖励",
    "team_rewards": "团队奖励",
    "view_detail": "详情"
  },
  "common": {
    "bind_success": "绑定成功!",
    "bind_fail": "绑定失败!",
    "training_success": "训练成功!",
    "training_fail": "训练失败!",
    "copy_success": "复制成功!",
    "withdraw_success": "提取成功!",
    "withdraw_fail": "提取失败!",
    "busy_network":"当前访问人数较多!",
    "loading": "加载中..."
  }
}